import { render, staticRenderFns } from "./BespokeSpooked.vue?vue&type=template&id=be699bec&scoped=true&"
import script from "./BespokeSpooked.vue?vue&type=script&lang=js&"
export * from "./BespokeSpooked.vue?vue&type=script&lang=js&"
import style0 from "./BespokeSpooked.vue?vue&type=style&index=0&id=be699bec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be699bec",
  null
  
)

export default component.exports